// extracted by mini-css-extract-plugin
module.exports = {"option":"option-SHgyE","label":"label-gTtLc","icon":"icon-lDn76"};